document.addEventListener('DOMContentLoaded', () => {

  const form = document.querySelector('.product-form form');
  const checkboxes = document.querySelectorAll(".bf-checkbox");

  if (!form) return;

  form.addEventListener('submit', async (e) => {

    const items = [];

    checkboxes.forEach(cb => {
      if (cb.checked) {
        items.push({
          id: Number(cb.value),
          quantity: 1
        });
      }
    });

    if (items.length === 0) return;

  
    setTimeout(() => {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      })
      .then(res => res.json())
      .then(() => fetch('/cart.js'))
      .then(res => res.json())
      .then(cart => {

        const bubble = document.querySelector('.cart-count') ||
                       document.querySelector('.cart-count-bubble') ||
                       document.querySelector('.header__cart-count') ||
                       document.querySelector('.cart__bubble-count');

        if (bubble) bubble.textContent = cart.item_count;

        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));

        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === "function") {
          drawer.open();
        }
      });
    }, 300); // let Shopify finish adding the main product

  });

});
